<div
  class="mbs-tags-input"
  ngbDropdown
  [container]="'body'"
  [dropdownClass]="dropdownClass"
  [placement]="placement">
  @if (label && id) {
    <mbs-input-label
      [boldLabel]="boldLabel"
      [disabled]="disabledState"
      [id]="id"
      [info]="info"
      [infoContainer]="infoContainer"
      [infoPlacement]="infoPlacement"
      [infoTriggers]="infoTriggers"
      [label]="label"
      [labelClasses]="labelClasses"
      [labelContentClasses]="labelContentClasses"
      [labelSize]="labelSize"
      [required]="hasRequiredValidator && showRequiredMark">
      <ng-content
        ngProjectAs="[prependLabel]"
        select="[prependLabel]" />

      <ng-content
        ngProjectAs="[appendLabel]"
        select="[appendLabel]" />
    </mbs-input-label>
  }

  <div
    #container
    class="mbs-tags-input_box"
    ngbDropdownAnchor
    [class.-error]="control?.invalid"
    [class.-focused]="isFocused"
    [class.overflow-hidden]="isCollapseMode"
    [style.max-height.px]="mode === modeEnum.Collapsed ? collapseHeight : scrollHeight"
    [style.min-height.px]="minHeight">
    @for (item of value; track item?.name ?? item) {
      <span
        class="mw-100"
        [container]="'body'"
        [ngbTooltip]="item?.tooltip">
        <mbs-tag
          [active]="item.active"
          [class.-error]="item.errors?.length"
          [class.bg-red-20]="item.errors?.length"
          [closable]="true"
          [color]="item.color"
          [disabled]="loading || item.disabled || disabled"
          [id]="idPrefix + item.name"
          [noBorder]="true"
          [size]="$any(size)"
          (mbsClose)="handleClose($index)">
          {{ item.name }}
        </mbs-tag>
      </span>
    }

    @if ((showExtendButton$ | async) === modeEnum.Collapsed) {
      <div class="mbs-tags-input_extend-button">
        <mbs-button
          [disabled]="disabled"
          [isDashed]="true"
          [type]="'muted'"
          (click)="mode = modeEnum.Opened">
          Show All
        </mbs-button>
      </div>
    }

    @if ((showExtendButton$ | async) === modeEnum.Opened) {
      <mbs-button
        class="align-self-center"
        [disabled]="disabled"
        [isDashed]="true"
        [type]="'muted'"
        (click)="mode = modeEnum.Collapsed">
        Hide All
      </mbs-button>
    }

    @if (!isStatic) {
      <input
        #inputField
        class="mbs-tags-input_input"
        ngbDropdownToggle
        [attr.aria-describedby]="id"
        [attr.aria-labelledby]="label"
        [autocomplete]="'off'"
        [class.-invalid]="inputControl.invalid"
        [formControl]="inputControl"
        [id]="id"
        [ngClass]="bindClasses"
        [placeholder]="placeholder"
        [readonly]="loading || inputControlReadonly || disabled || disabledSelf"
        [tabindex]="tabindex"
        (blur)="handleBlur()"
        (focus)="handleFocus()"
        (input)="handleChange($event)"
        (keydown)="handleKeyDown($event)" />
    }

    @if (loading) {
      <span class="loader ml-auto mr-2 d-inline-flex align-self-center"></span>
    }
  </div>

  @if (control.invalid) {
    <mbs-input-errors [errors]="mapErrors(control.errors)" />
  }

  @if (!isStatic) {
    <div
      aria-labelledby="tags-menu-button"
      class="mbs-tags-input_dropdown"
      ngbDropdownMenu
      [style.max-width.px]="container.offsetWidth > 250 ? container.offsetWidth : 250">
      @if (isSuggestionsActionButtonVisible()) {
        <mbs-button
          class="border-bottom pb-2"
          ngbDropdownItem
          [customClasses]="'overflow-hidden'"
          [disabled]="disabled"
          [isCtrl]="true"
          (click)="onActionButtonPressed()">
          <span class="text-overflow lh-base"> {{ actionButton }} {{ inputControl.value }} </span>
        </mbs-button>
      }

      @for (suggestion of filteredSuggestions; track suggestion?.name ?? suggestion) {
        <button
          class="overflow-hidden"
          ngbDropdownItem
          [disabled]="disabled"
          (click)="onSuggestionItemClick(suggestion)">
          @if (suggestion?.type === suggestionType.Tag) {
            <mbs-tag [color]="suggestion.color">
              {{ suggestion?.name }}
            </mbs-tag>
          } @else {
            <span class="text-overflow">
              {{ suggestion?.name }}
            </span>
          }
        </button>
      }
    </div>
  }
</div>
